const dateSortMethod = (a, b) => {
  const a1 = new Date(a).getTime();
  const b1 = new Date(b).getTime();
  if (a1 < b1) return 1;
  if (a1 > b1) return -1;
  return 0;
};

export default dateSortMethod;
